//Represents generic response message structure from server
export class GenericResponse {
    ok: boolean;
    message: string;
    payload: JSON;

    constructor(response: JSON) {
        this.ok = response['ok'];
        this.message = response['message'];
        if(response.hasOwnProperty('leftNavItems'))
            this.payload = response['leftNavItems'];
        else
            this.payload = response['responseData'];
    }
}
